require('./mortgageRequestCoHolderView.scss');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');

// @ helpers
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const { contactCenterClassName } = require('utilities/conditionals/conditionalClassname')

// @ commons
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const { ContentBox } = require('commonsComponents/contentBox');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');

// @ components
const { MortgageRequestCoHolder } = require('components/mortgageRequest/mortgageRequestCoHolder/mortgageRequestCoHolder');
const MortgageRequestNoCoHolderMessage = require('components/mortgageRequest/mortgageRequestNoCoHolderMessage/mortgageRequestNoCoHolderMessage');

class MortgageRequestCoHolderView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            holderType: 1
        };

        this.handleHolderTypeRadioChange = this.handleHolderTypeRadioChange.bind(this);
    }

    handleHolderTypeRadioChange(value) {
        this.setState({
            holderType: parseInt(value),
        });
    }

    render() {
        const { immGlobalPosition } = this.props;
        const isClientWithoutAccounts = immGlobalPosition.get("isClientWithoutAccounts");
        const mappingBreadcrumb = [
            {
                text: formatText('navbar-loans'),
                url: '/myprofile/loans-mortgages'
            },
            {
                text: formatText('mortgageRequestPresentation-title'),
                url: '/myprofile/mortgage/panel'
            },
            {
                text: formatText('mortgageRequestCoHolder-title'),
                url: ''
            }
        ].filter((config, index) => (isClientWithoutAccounts && index !== 0) || !isClientWithoutAccounts);

        let mortgageRequestComponent;

        if (this.state.holderType == 1) {
            mortgageRequestComponent = <MortgageRequestCoHolder />
        } else if (this.state.holderType == 2) {
            mortgageRequestComponent = <MortgageRequestNoCoHolderMessage />
        }

        const mortgateRequestClassName = contactCenterClassName('mortgage-request-co-holder-view__body', 'grid-view__body')
        return (
            <div className="mortgage-request-co-holder-view">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="loansmortgages" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                finalTitle={getFinalTitle('mortgageRequestCoHolder-titleHeader')}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className={mortgateRequestClassName}>
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            <div className="col-xs-12">
                                <ContentBox title={formatText('mortgageRequestCoHolder-subtitle')} smallTitle={true}>
                                    <RadioButtonGroup
                                        selectedValue={this.state.holderType}
                                        onChange={this.handleHolderTypeRadioChange}
                                        name="coHolderType"
                                        idPrefix="coHolderType"
                                    >
                                        <RadioButton
                                            label={formatText('mortgageRequestCoHolder-coholderType1')}
                                            value={1}
                                            className="mortgage-request-co-holder-view__radio-button"
                                        />
                                        <RadioButton
                                            label={formatText('mortgageRequestCoHolder-coholderType2')}
                                            value={2}
                                            className="mortgage-request-co-holder-view__radio-button"
                                        />
                                    </RadioButtonGroup>
                                </ContentBox>
                                {mortgageRequestComponent}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

MortgageRequestCoHolderView.propTypes = {
    match: PropTypes.object.isRequired,
    immGlobalPosition: PropTypes.object.isRequired
};

module.exports.MortgageRequestCoHolderView = connect(
    state => ({
        immGlobalPosition: state.globalPosition,
    }), null
)(MortgageRequestCoHolderView);
